import { render } from "./ThankView.vue?vue&type=template&id=22403385&scoped=true&ts=true"
import script from "./ThankView.vue?vue&type=script&lang=ts"
export * from "./ThankView.vue?vue&type=script&lang=ts"

import "./ThankView.vue?vue&type=style&index=0&id=22403385&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22403385"]])

export default __exports__